<template>
  <div>
    <div class="row" style="padding: 1%;">
      <div class="col-lg-12">
        <h4 class="info-text">BAHAGIAN C - Siasatan Punca Kejadian</h4>
        <u>
          <p>Nota Penting</p>
        </u>
        <ol>
          <li>
            <p style="font-style: italic">
              Siasatan dilakukan merangkumi faktor "
              <b>4M - Man, Machine, Materials &amp; Method</b>" untuk mengenalpasti punca kejadian.
            </p>
          </li>
          <li>
            <p style="font-style: italic">
              Kaedah "
              <b>Why-Why</b>"
              digunakan bagi setiap punca awal tang dikenalpasti untuk mendapatkan punca sebenar kejadian.
            </p>
          </li>
          <li>
            <p style="font-style: italic">
              Jika ada faktor yang tidak berkaitan sila tulis "
              <b>tidak berkaitan</b>"
            </p>
          </li>
        </ol>
        <div class="row justify-content-center">
          <div class="col-sm-6">
            <u>
              <h4 class="info-text">C1 - Punca Disebabkan Oleh Manusia (Man)</h4>
            </u>
            <textarea class="huraian" @change="senddata()" v-model="man"></textarea>
          </div>
          <div class="col-sm-6">
            <u>
              <h4 class="info-text">C2 - Punca Disebabkan Oleh Mesin (Machine)</h4>
            </u>
            <textarea class="huraian" @change="senddata()" v-model="machine"></textarea>
          </div>
          <div class="col-sm-6">
            <u>
              <h4 class="info-text">C3 - Punca Disebabkan Oleh Peralatan / Bahan (Material)</h4>
            </u>
            <textarea class="huraian" @change="senddata()" v-model="material"></textarea>
          </div>
          <div class="col-sm-6">
            <u>
              <h4 class="info-text">C4 - Punca Disebabkan Oleh Sistem Kerja (Method)</h4>
            </u>
            <textarea class="huraian" @change="senddata()" v-model="method"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker
  },
  data() {
    return {
      instid: "",
      value1: "",
      tableSiteRoute: [
        {
          siteRoute: "Route A"
        },
        {
          siteRoute: "Route B"
        }
      ],
      selects: {
        condition: [
          { value: "operational", label: "Operational" },
          { value: "Not operational", label: "Not Operational" }
        ]
      },
      model: {
        file: null
      },
      man: "",
      machine: "",
      material: "",
      method: ""
    };
  },
  created(){
    this.getInstId();
    

  },
  methods: {
    onFileChange(file) {
      this.file = file;
    },
    validate() {
      // this.$emit("on-validated", true, this.model);
      let fifth = {
        man : this.man,
        machine : this.machine,
        material : this.material,
        method : this.method
      }

      console.log(fifth)
      this.$root.$emit("fifthpage", fifth)
      return Promise.resolve(true);
    },
    getInstId(){
      this.$root.$on("instid", instid =>{
        console.log(instid)
        this.instid = instid
        this.getData();
      })
    },
    getData(){
      this.$http.get(":9994/api/v1/incident/method/" + this.instid)
        .then(res=>{
          if(!res.error){
            let response = res.message
            console.log(response)
            for(var i=0; i<response.length; i++){
              this.man = response[i].CauseByHuman
              this.machine = response[i].CauseByMachine
              this.material = response[i].CauseByMaterial
              this.method = response[i].CauseByMethod
            }
          }
        })
    },
    senddata(){
      console.log(this.man)
      console.log(this.machine)
      console.log(this.material)
      console.log(this.method)

      
    }
  }
};
</script>
<style scoped>
textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
.huraian {
  width: 100%;
  height: 250px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
</style>
